<template>
  <b-table-simple class="details-table text-center" small responsive>
    <b-thead head-variant="dark">
      <b-tr>
        <b-th style="width:25%">Session Date</b-th>
        <b-th style="width:15%">Outcome</b-th>
        <b-th style="width:15%">Payment Status</b-th>
        <b-th>Session Info</b-th>
      </b-tr>
    </b-thead>
    <b-tbody>
      <b-tr v-for="(detail, index) in details" :key="index">
        <b-td class="default-cell">{{ detail.start | asMoment | withTimeZone | format('M/D/YYYY h:mmA (z)') }}</b-td>
        <b-td :variant="styleOutcomeType(detail.outcomeType)">{{ detail.outcomeType }}</b-td>
        <b-td class="default-cell"> {{ detail.payment.status == 'Paid' ? 'Paid - 1 Credit' : detail.payment.status }}</b-td>
        <b-td class="default-cell">{{ detail.publicExplainer ? detail.publicExplainer : '-' }}</b-td>
      </b-tr>
    </b-tbody>
  </b-table-simple>
</template>

<script>
export default {
    name: 'OutcomeDetailsTable',
    props:{
        details: {
            type: Array,
            required: true,
    }
  },
  methods:{
    styleOutcomeType(type) {
      switch (type) {
        case 'Successful':
          return 'success'
        case 'User Late Canceled':
          return 'warning';
        case 'User No Show':
          return 'warning'
        default:
          return '';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.details-table {
  margin-bottom: 0 !important;
  border: 1px solid $dark-blue;
  border-radius: 5px;
  // .thead-dark th {
  //   border-bottom: 1px solid grey !important;
  // }
  td {
    border-top: 1px solid $dark-blue;
    border-left: 1px solid $dark-blue;
    &.default-cell {
      background-color: white;
    }
  }

  .table-success, .table-success > th, .table-success > td {
    background-color: #00d40466;
  }
}

</style>
